import { NavLink, useLocation } from 'react-router-dom';
import {
  DESKTOP_DOCK_ITEMS,
  MOBILE_NAV_ITEMS,
  isDockDestinationActive,
  type DockDestination,
} from './navigation';

interface CommandDockProps {
  mobile: boolean;
}

export function CommandDock({ mobile }: CommandDockProps) {
  const location = useLocation();
  const items = mobile ? MOBILE_NAV_ITEMS : DESKTOP_DOCK_ITEMS;

  return (
    <nav
      className={mobile ? 'mobile-command-nav' : 'command-dock'}
      aria-label={mobile ? 'Mobile primary' : 'Primary'}
      data-testid={mobile ? 'mobile-nav' : 'command-dock'}
    >
      <ul className={mobile ? 'mobile-command-nav__list' : 'command-dock__list'}>
        {items.map((item) => (
          <li key={item.id}>
            <DockLink item={item} active={isDockDestinationActive(location.pathname, item)} />
          </li>
        ))}
      </ul>
    </nav>
  );
}

function DockLink({ item, active }: { item: DockDestination; active: boolean }) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      end={item.to === '/'}
      className={`dock-item${active ? ' is-active' : ''}`}
      data-testid={`dock-${item.id}`}
      data-availability={item.availability}
      aria-current={active ? 'page' : undefined}
      title={item.availability === 'planned' ? `${item.label} (planned)` : item.label}
    >
      <Icon />
      <span>{mobileLabel(item)}</span>
      {active && <span className="sr-only"> (current)</span>}
    </NavLink>
  );
}

function mobileLabel(item: DockDestination): string {
  // Keep full labels; CSS handles overflow / scroll on narrow widths.
  return item.shortLabel || item.label;
}
